<div class="content-inner" [ngClass]="layoutService.expandedMenu ? 'expand' : ''">
    <div class="title-bar">
        <div class="container-fluid">
            <div class="row">
                <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                    <div class="col-auto">
                        <h2 class="page-title">{{ 'GENERAL.MY_TASK' | translate }}</h2>
                    </div>
                    <div class="col-auto d-flex justify-content-md-end justify-content-sm-start">
                        <div class="col-auto institution-name pl-0">
                            <!-- <img alt="Institution" src="assets/img/svg/icon-help.svg"> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row justify-content-between mt-4 mb-4 align-items-center">
            <div class="col-auto">
                <!-- <button (click)="addUser()" class="btn btn-primary">{{ 'USER_MANAGEMENT.ADD_USER' | translate }}</button> -->
            </div>
            <div class="col-auto">
                <input inputSanitizer type="text" class="form-control search-input" [(ngModel)]="searchText" placeholder="{{ 'INSTITUTION_MANAGEMENT.SEARCH' | translate }}..." />
            </div>
        </div>

        <div class="my-4">
            <div class="col-12 static-card">
                <bd-light-table 
                [gridData]="gridData || [] | search:searchText:['user','name','email','role','roleName','institutions','city','institutionName']" 
                [pageInfo]="pageInfo" 
                [fields]="fields" 
                [actions]="actionItems"
                ></bd-light-table>
            </div>
            <!-- <lib-ph-bhp-grid [horizontalAction]="horizontalAction" [gridData]="gridData | search:searchText:['user','name','email','role','roleName','institutions','city','institutionName']" 
            [fields]="fields" [gridGroupable]="true" [pageInfo]="pageInfo" [actionItems]="actionItems"></lib-ph-bhp-grid> -->
        </div>
    </div>
</div>

<ng-template #delmodal>
    <div class="modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar>
        <p>{{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD' | translate }}</p>
    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col my-3 justify-content-center align-items-center d-flex">
                    <button (click)="modalRef.hide()" class="btn btn-cancel mr-4">{{ 'AUTHORIZATION.CANCEL' | translate }}</button>
                    <button (click)="delete();modalRef.hide()" class="btn btn-primary">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>